(function(window, captionServiceFactory) {
   'use strict';

   var namespace = window.TSC = window.TSC || {};
   namespace.CaptionService = captionServiceFactory(window.tscme, window.tinycolor);
})(this, function(tscme, tinycolor) {
   'use strict';

   var _defaultTextColorObject = Object.freeze(tinycolor({r: 255, g: 255, b: 255, a: 1.0}));
   var _defaultBgColorObject = Object.freeze(tinycolor({r: 0, g: 0, b: 0, a: 0.9}));

   var _defaults = Object.freeze({
      captionFontFamily: 'Arial, Helvetica, sans-serif;',
      captionFontSize: 24,
      captionFontSizeMin: 14,
      captionFontSizeMax: 144,
      captionTextColor: _defaultTextColorObject,
      captionBgColor: _defaultBgColorObject,
      captionPosition: 'overlay',
      captionBarHeight: 0
   });

   /**
    * @memberof TSC
    * @class CaptionService
    * @classdesc The caption service
    */
   var CaptionService = function() {
      var _position = _defaults.captionPosition;
      var _barHeight = _defaults.captionBarHeight;
      var _font = _defaults.captionFontFamily;
      var _fontSize = _defaults.captionFontSize;
      var _fontSizeMin = _defaults.captionFontSizeMin;
      var _fontSizeMax = _defaults.captionFontSizeMax;
      var _textColor = _defaults.captionTextColor.clone();
      var _backgroundColor = _defaults.captionBgColor.clone();
      var _captionTrack = tscme.CaptionTrack.create({captions: []});

      var setFontSize = function(value) {
         _fontSize = Math.min(Math.max(value, _fontSizeMin), _fontSizeMax);
      };

      var initFromXmp = function(xmp) {
         _position = xmp.captionPosition;
         _barHeight = xmp.captionBarHeight;
         _font = xmp.captionFontFamily;
         _fontSize = xmp.captionFontSize;
         _fontSizeMin = xmp.minCaptionFontSize;
         _fontSizeMax = xmp.maxCaptionFontSize;
         _textColor = tinycolor(xmp.captionTextColor);
         _backgroundColor = tinycolor(xmp.captionBg);
         _captionTrack = xmp.captionTrack;
      };

      return Object.defineProperties({
         initFromXmp: initFromXmp
      }, {
         position: {
            get: function() {
               return _position;
            }
         },
         height: {
            get: function() {
               return _barHeight;
            }
         },
         font: {
            get: function() {
               return _font;
            },
            set: function(value) {
               _font = value;
            }
         },
         fontEnclosedWithQuotes: {
            get: function() {
               var fontFamilies = _font.split(',');
               var quotedFontFamilies = fontFamilies.map(function(fontFamily) {
                  return '\'' + fontFamily.trim() + '\'';
               });
               return quotedFontFamilies.join(',');
            }
         },
         fontSize: {
            get: function() {
               return _fontSize;
            },
            set: setFontSize
         },
         fontSizeMin: {
            get: function() {
               return _fontSizeMin;
            }
         },
         fontSizeMax: {
            get: function() {
               return _fontSizeMax;
            }
         },
         textColor: {
            get: function() {
               return _textColor;
            },
            set: function(value) {
               _textColor = tinycolor(value);
            }
         },
         backgroundColor: {
            get: function() {
               return _backgroundColor;
            },
            set: function(value) {
               _backgroundColor = tinycolor(value);
            }
         },
         backgroundOpacity: {
            get: function() {
               return _backgroundColor.getAlpha();
            },
            set: function(value) {
               _backgroundColor.setAlpha(value);
            }
         },
         captionTrack: {
            get: function() {
               return _captionTrack;
            },
            set: function(value) {
               _captionTrack = value;
               _backgroundColor = tinycolor({r: _captionTrack.bgColor.r, g: _captionTrack.bgColor.g, b: _captionTrack.bgColor.b, a: _captionTrack.bgOpacity});
               _textColor = tinycolor({r: _captionTrack.fgColor.r, g: _captionTrack.fgColor.g, b: _captionTrack.fgColor.b});
               setFontSize(_captionTrack.fontSize);
               _font = _captionTrack.fontFamily;
               _barHeight = _captionTrack.barHeight;
               _position = _captionTrack.position;
            }
         },
         hasCaptions: {
            get: function() {
               return _captionTrack.captionCollection.captions.length > 0;
            }
         }
      });
   };

   return {
      /**
       *  Factory method that returns a new CaptionService object.
       *  @function create
       *  @memberof TSC.CaptionService
       *  @static
       *  @return new CaptionService instance
       */
      create: function() {
         return CaptionService();
      },
      defaults: function() {
         return _defaults;
      }
   };
});
